









































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { predefineColors } from '../../../constant/options';
import YcColorPicker from '@/components/color-picker/index.js';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import { getVueAppUploadApi } from '@/services/util';
import { ensureFileScopeAuthorized } from '@/services/fileScope';
import { popupImageBeforeUpload } from '@/utils/popupImageCompression';
import CloseButtonSetting from './CloseButtonSetting.vue';
import { isEnableCloseButtonAdvanced, isEnablePopupLayoutModeToggle, isFullscreenPopupLayoutAllowed } from '@/utils/experiment';
import { normalizePopupLayoutRules, restoreFullscreenContainerBorderRadius } from '@/views/wheelOfFortune/utils/popupLayoutRules';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'close-button-setting': CloseButtonSetting,
  }
})
export default class wheelOfFortuneTextCover extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;
  predefineColors = predefineColors;
  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  zpbgUploadFileList: { name: string; url: string }[] = [];
  zpbgUploadShow = false;

  get formStyle() {
    // 封面设置页面不需要复杂的表单样式
    return '';
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  created() {
    // 确保 cover 对象在组件创建时就存在
    if (!this.formDataStart.settings.cover) {
      this.formDataStart.settings.cover = {
        coverJumpType: 'click',
        bgCoverImgUrl: undefined,
      };
    }
  }

  changeStart() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    (window as any)?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }
  changeStartGA() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    (window as any)?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  get enableCloseButtonAdvanced() {
    return isEnableCloseButtonAdvanced();
  }

  get enablePopupLayoutModeToggle() {
    const templateId = String(this.$route.query.templateid || this.formDataStart?.templateId || this.formData?.templateId || '');
    return (
      isEnablePopupLayoutModeToggle() &&
      isFullscreenPopupLayoutAllowed(templateId, this.triggerEventType)
    );
  }

  get popupLayoutModeModel(): string {
    return this.formDataStart.settings.rules.popupLayoutMode === 'fullscreen' ? 'fullscreen' : 'standard';
  }

  get disableStandardPopupLayoutMode(): boolean {
    return Number(this.formDataStart?.popWindowWheel) === 3;
  }

  set popupLayoutModeModel(val: string) {
    if (val === 'standard' && this.disableStandardPopupLayoutMode) {
      this.$set(this.formDataStart.settings.rules, 'popupLayoutMode', 'fullscreen');
      this.$message.warning('当前模板不支持切换为标准弹窗');
      return;
    }
    const mode = val === 'fullscreen' ? 'fullscreen' : 'standard';
    this.$set(this.formDataStart.settings.rules, 'popupLayoutMode', mode);
    if (mode === 'fullscreen') {
      normalizePopupLayoutRules(this.formDataStart, { capturePrevOnEnter: true });
    } else {
      const rules: any = this.formDataStart.settings.rules;
      const prev = rules._prevFullscreenImgPositions;
      if (prev && typeof prev === 'object') {
        const ts: any = this.formDataStart.settings.typesetting || {};
        if (prev.imgPosition) ts.imgPosition = prev.imgPosition;
        if (prev.middleImgPosition) ts.middleImgPosition = prev.middleImgPosition;
        if (prev.endImgPosition) ts.endImgPosition = prev.endImgPosition;
        if (prev.wheelPosition) ts.wheelPosition = prev.wheelPosition;
        delete rules._prevFullscreenImgPositions;
      }
      restoreFullscreenContainerBorderRadius(this.formDataStart);
    }
    (window as any)?.gtagClick?.('form_edit_setType', '弹窗_编辑订阅工具_设置表单类型');
    this.changeStart();
  }

  handleCloseButtonChange(config: any) {
    // 同步更新 cover.closeColor 以保持兼容
    if (config && config.iconColor) {
      this.formDataStart.settings.cover.closeColor = config.iconColor;
      // 同时同步到 rules.closeColor 以确保 pop.vue 预览兼容性
      if (this.formDataStart.settings.rules) {
        this.formDataStart.settings.rules.closeColor = config.iconColor;
      }
    }
    this.changeStart();
    (window as any)?.gtagClick?.('form_edit_setCloseButton', '弹窗_编辑订阅工具_设置关闭按钮');
  }

  @Watch('formData')
  changeFormData() {
    this.formDataStart = this.formData;
  }

  @Watch('formData.settings.cover.bgCoverImgUrl', { immediate: true })
  typesettingBGCoverImgUrlChange(val: string) {
    if (val) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  zpbgHandleError(e: any): void {
    this.zpbgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  zpbgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.zpbgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.cover && (
        this.formDataStart.settings.cover.bgCoverImgUrl = res.data[0].url
      );
      this.zpbgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.zpbgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  zpbgBeforeUpload(file: File): Promise<File | Blob | boolean> {
    return popupImageBeforeUpload(file, this.$message).then((uploadFile) => {
      if (!uploadFile) {
        return false;
      }
      // 新增需求：图片压缩通过后仍需保留上传授权校验。
      return ensureFileScopeAuthorized().then(() => {
        this.zpbgUploadShow = true;
        return uploadFile;
      });
    });
  }
  /**
   * 删除图片
   */
  zpbgUploadUrlDelete() {
    this.zpbgUploadShow = false;
    this.formDataStart?.settings?.cover && (
      this.formDataStart.settings.cover.bgCoverImgUrl = ''
    );
    this.changeStart();
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }
}
